import React from "react";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { useDispatch } from "react-redux";
import { deleteUserPhoneNumber } from "Bands/state";

const { userPhoneNumber: phoneCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserPhoneNumberModal: React.FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserPhoneNumber(id));
  };

  return (
    <DeleteUserEntityModal
      type="phone number"
      action={USER_ACTIONS.deleteUserPhoneNumber}
      successMessage={phoneCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
